var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigPlay",on:{"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')},"click":_vm.clicked}},[_c('BigPlayIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }